import { getApplicationSettings } from 'owa-application-settings';
import { lazyMountAndShowFullOptions } from 'owa-options-view';

export async function openDirectivesSettings(): Promise<void> {
    const { optionsCategory } = getApplicationSettings('CalendarInstructions');
    lazyMountAndShowFullOptions.importAndExecute(optionsCategory, 'calendarInstructions');
}
